import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/departamentos/';

/**
 * GET Departamentos
 * @returns {Promise<Array<object>>}
 */
export const getDepartamentos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Departamento
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDepartamento = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Horarios Departamento
 * @param {number} id
 * @param {object} values
 * @returns {Promise<Array<object>>}
 */
export const getHorariosDepartamento = async (id, values) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Departamento
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDepartamento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Departamento
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDepartamento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Departamento
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteDepartamento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
